import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.29829 2.39892C9.7853 1.70319 10.7626 1.4517 11.5258 1.9765C12.3189 2.52179 13.6903 3.5757 14.8707 5.05519C16.0505 6.53396 17.0837 8.49509 17.0837 10.8332C17.0837 14.9977 13.9568 18.3332 10.0003 18.3332C6.04385 18.3332 2.91699 14.9977 2.91699 10.8332C2.91699 9.1371 3.64539 6.96994 5.06494 5.23974C5.68688 4.48169 6.76004 4.52691 7.38705 5.12927L9.29829 2.39892ZM10.0003 16.6666C11.2084 16.6666 12.1878 15.5486 12.1878 14.1696C12.1878 12.6898 11.0368 11.6013 10.4047 11.1151C10.1633 10.9294 9.83736 10.9294 9.596 11.1151C8.96381 11.6013 7.81283 12.6898 7.81283 14.1696C7.81283 15.5486 8.7922 16.6666 10.0003 16.6666Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }